import React, { useEffect} from 'react';
import { withNamespaces } from 'react-i18next';
import { IsEnglish } from '../../utils/language';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTriangleExclamation, faEnvelope } from "@fortawesome/pro-solid-svg-icons"
import { faMailboxFlagUp } from "@fortawesome/pro-solid-svg-icons"
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import i18next from 'i18next';
import background_messaging from "../../images/background_messaging.png";
import * as MessageLevel from '../../scripts/MessageLevelCode';

const useStyles = makeStyles((theme) => ({
    divRootMessage: {
        margin: '10px',
        color: 'var(--color3)',
        textAlign: 'left',
        '& > svg': {
            margin: '0px 10px 0px 5px',
            fontSize: '20px'
        }
    },
    divMessage: {
        margin: '5px',
        '& li:first-child': {
            borderTop: '0',
            paddingTop: '0'
        },
    },
    liMessage: {
        textAlign: 'left',
        color: '#ffffff',
        marginBottom: '10px',
        '& > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
        '& > span': {
            display: 'table',
            paddingRight: '27px'
        },
        borderTop: '1px solid #ffffff70',
        paddingTop: '10px',
        display: 'flex'
    },
    headerNormalMsgDiv: {
        height: '60px',
        backgroundColor: 'var(--color1)!important',
        color: 'var(--color2)!important'
    },
    headerHighLevelMsgDiv: {
        height: '60px',
        backgroundColor: 'var(--color15)!important',
        color: 'var(--color2)!important'
    },
    titleMessage: {
        float: 'left !important',
        display: 'flex'
    },
    closeButton: {
        float: 'right',
        marginTop: '-9px'
    },
    divPopup: {
        '& > div.MuiDialog-container > div.MuiDialog-paper': {
            minWidth: 'calc(100% - 50px)'
        }
    },
    divEntireMessage: {
        marginBottom: '10px'
    },
    spanNoContent: {
        color: '#ffffff',
        display: 'table',
        width: '100%',
        marginTop: '35px'
    },
    divBackMessaging: {
        minHeight: '100px',
        maxHeight: '280px',
        overflow: 'auto',
        borderRadius: '8px',
        display: 'inline-block',
        width: '100%'
    },
    divRootMessaging: {
        color: '#ffffff',
        display: 'inline-block',
        float: 'left',
        paddingBottom: '5px',
        width: '100%',
        textAlign: 'left',
        '& > svg': {
            float: 'left',
            margin: '0 !important'
        },
        display: 'flex',
        alignItems: 'center'
    },
    messagingImg: {
        width: '35px',
        marginTop: '2px'
    },
    messagingTitle: {
        verticalAlign: 'middle',
        marginLeft: '10px',
        fontVariant: 'all-petite-caps',
        fontSize: '18px'
    }
}));

function Messaging(props) {
    const classes = useStyles();

    const [openMessage, setOpenMessage] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [messageLevel, setMessageLevel] = React.useState('');
    const [data, setData] = React.useState(null);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined && props.data.length > 0) {
            setData(props.data);
        }
    }, [props.data]);

    const handleCloseMessage = () => {
        setOpenMessage(false);
    }

    const handleDisplayMessage = (obj) => {
        setOpenMessage(true);
        setMessage(IsEnglish() ? obj.htmlEnglish : obj.htmlFrench);
        setMessageLevel(obj.importance);
    }

    return (
        <>
            <div className={classes.divRootMessaging}>
                <FontAwesomeIcon icon={faMailboxFlagUp} style={{fontSize: '32px' }} />

                <span className={classes.messagingTitle}>Messages</span>
            </div>
            <div className={classes.divBackMessaging}>
                <ul className={classes.divMessage}>
                    {data && data.map((obj, index) =>
                        <li key={index} className={classes.liMessage} onClick={() => handleDisplayMessage(obj)}>
                            {obj.importance == MessageLevel.HIGH ? (
                                <FontAwesomeIcon icon={faTriangleExclamation} beat className="fa-w-16" style={{ color: 'rgb(239 88 88)', fontSize: '20px', display: 'flex', alignSelf: 'center' }} />
                            ) : (
                                    <FontAwesomeIcon icon={faEnvelope} className="fa-w-16" style={{ fontSize: '20px', display: 'flex', alignSelf: 'center' }} />
                            )}

                            <span style={{ paddingLeft: '5px'}}>{IsEnglish() ? obj.textEnglishAbbr : obj.textFrenchAbbr} ...</span>
                        </li>
                    )}
                </ul>
                {(data === null) && <span className={classes.spanNoContent}>{i18next.t("home:homeContent.noMessage")}</span>}
            </div>
            <Dialog
                open={openMessage}
                onClose={handleCloseMessage}
                aria-labelledby="draggable-dialog-title"
                className={classes.divPopup}                
            >
                <DialogTitle id="draggable-dialog-title" className={classes.headerNormalMsgDiv}>
                    <div className={classes.titleMessage}>
                        {messageLevel == MessageLevel.HIGH &&
                            <FontAwesomeIcon icon={faTriangleExclamation} beat className="fa-w-16" style={{ color: 'rgb(239 88 88)', fontSize: '20px', display: 'flex', alignSelf: 'center', paddingRight: '10px' }} />
                        }

                        Message
                    </div>
                    <div className={classes.closeButton}>
                        <IconButton edge="end" aria-label="edit" onClick={handleCloseMessage} style={{ color: '#ffffff' }}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className={classes.divEntireMessage} dangerouslySetInnerHTML={{ __html: message }} />
                </DialogContent>
            </Dialog>
        </>
    );
}
export default withNamespaces(['HomeContent'], { wait: true })(Messaging);